import React from 'react';

import './DrawerPanel.scss';

export const DrawerPanel = ({ children, dismissCallback }: { children: React.ReactElement, dismissCallback?(): void; }) => {
  return (
    <>
      <div styleName="backdrop" onClick={dismissCallback} />
      <div styleName="panel">
          {children}
      </div>
    </>
  );
};

export default DrawerPanel;
